.ux-steps-item {
  @include font(bold);

  align-items: center;
  background: $color-white;
  border: 2px solid $color-gray-inactive;
  border-radius: 50%;
  color: $color-gray-inactive;
  display: flex;
  flex: 0 0 auto;
  font-size: $size-text-small;
  height: 30px;
  justify-content: center;
  margin-right: 50px;
  position: relative;
  width: 30px;
  z-index: $z-index-steps-item;

  @media only screen and (width >= 768px) {
    border: 3px solid $color-gray-inactive;
  }

  @media only screen and (width >= 1024px) {
    margin-right: 110px;
  }

  &:last-child {
    margin-right: 0;
  }

  &:first-child::before {
    display: none;
  }

  &::before {
    background: $color-gray-inactive;
    content: "";
    height: 2px;
    left: -0.5px;
    position: absolute;
    transform: translateX(-100%);
    width: 51.5px;
    z-index: $z-index-steps-items-before;

    @media only screen and (width >= 768px) {
      height: 3px;
      left: 0;
      width: 53.5px;
    }

    @media only screen and (width >= 1024px) {
      width: 113px;
    }
  }

  &__text {
    @include font(bold);

    bottom: 0;
    color: $color-gray-inactive;
    display: none;
    font-size: $size-text-smaller;
    left: 50%;
    margin: 0;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    transform: translateX(-50%) translateY(calc(100% + 13px));
    width: 200%;

    @media only screen and (width >= 1024px) {
      width: 300%;
    }
  }
}

.ux-steps-item--done {
  background: $color-green;
  border: 2px solid $color-green;
  color: $color-white;

  @media only screen and (width >= 768px) {
    border: 3px solid $color-green;
  }

  &::before {
    background: $color-green;
  }

  ux-icon {
    fill: $color-white;
  }

  .ux-steps-item__text {
    color: $color-green;
  }
}

.ux-steps-item--active {
  background: $color-white;
  border: 2px solid $color-green;
  color: $color-green;

  @media (width >= 768px) {
    border: 3px solid $color-green;
  }

  &::before {
    background: $color-green;
  }

  .ux-steps-item__text {
    color: $color-green;
  }
}

@media (width >= 576px) {
  .ux-steps-item {
    font-size: $size-text-normal;
    height: 42px;
    width: 42px;
  }
}

@media (width >= 1024px) {
  .ux-steps-item {
    height: 50px;
    width: 50px;
  }

  .ux-steps-item__text {
    display: block;
    font-size: $size-text-small;
  }
}
